import React, { useState } from 'react';
import { IconButton, Popover, Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function ProjectInfo({template}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
  return (
    <div>
      <IconButton onClick={handleClick} size="small">
        <InfoOutlinedIcon color="action" />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box>
            <Typography sx={{ p: 2, maxWidth: 600, display: 'flex', gap: 1 }}>
                Template Name: <strong> {template?.title ? template.title : 'Not Selected'} </strong>
            </Typography>
        </Box>
      </Popover>
    </div>
  )
}

export default ProjectInfo